<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>Aneks do umowy {{ shortNrUmowy() }}</strong>
</p>
<p>
    Zawarty w Łodzi pomiędzy:
</p>
<p><strong>Zleceniodawcą:</strong></p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
  Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
  Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod
  nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, reprezentowaną przez: 
</p>
<p>
  <strong>{{zamawiajacy}}</strong>,
</p>
<p>a</p>

  <strong>Zleceniobiorcą:</strong>
  <br/>
  Imię i nazwisko: {{imieNazwisko}}
  <br/>
  Pesel: {{pesel}}
  <br/>
  Adres: {{zamieszkany}}
  <br/>
  <br/>

  <p align="center"><strong>Warunki aneksu</strong></p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1</strong>
</p>
<p>Strony zgodnie postanawiają, że od dnia {{ dataAneksu }}r. ulega zmianie zapis dotyczący wynagrodzenia, które wynosić będzie <strong>{{ kwota }}zł brutto</strong> za godzinę.</p>
<p align="center" style="margin-bottom: 0px;">
  <strong>§ 2</strong>
</p>
<p>Pozostałe warunki umowy pozostają bez zmian.</p>

<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">{{zamawiajacy}}</span><br>
        <span style="margin-left: 0%;">Tutore Poland</span>
    </div>
    <div class="right-cointainer">
        {{imieNazwisko}}<br>
        <span style="margin-left: 0%;">Zleceniobiorca</span>
    </div>
</div>


  </td></tr>
  </tbody></table>

  </v-container>
</template>

<script>
import UmowaMonitoring from './UmowaMonitoring'

export default {
  name: 'UmowaAneksCentrala2023',
  components: {
    UmowaMonitoring
  },
  props: {
  },
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrumowy: '',
      datapocz: '',
      datakon: '',
      kwota: '',
      wypo: '',
      slownie: '',
      kwotapokaz: '',
      slowniepokaz: '',
      shortUmowa: '',
      nazwa1: '',
	    nazwa2: '',
	    nazwa3: '',
      ubezpieczenie: '',
      dataAneksu: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      let shortPosition = ''
      tab = this.nrumowy.split('/')
      switch(tab[3]) {
        case 'KonsultantInfolinia':
          shortPosition = 'INF'
          break;
        case 'KonsultantCC':
          shortPosition = 'CC'
          break
        case 'KonsultantTurystyka':
          shortPosition = 'TUR'
          break
        case 'GrupaWsparciaTechnicznego':
          shortPosition = 'GWT'
          break
        case 'ManagerPlacowkiEdukacyjnej':
          shortPosition = 'MPE'
          break
        case 'Specjalista ds. Rozwoju Sieci Sprzedaży':
          shortPosition = 'RSS'
          break
        case 'Nauczyciel':
          shortPosition = 'Naucz'
          break
        default:
          shortPosition = tab[3]
      }
      this.shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
      return this.shortUmowa
    },
    dataObowiazywaniaUmowy () {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'podpisania umowy przez obie strony'
      } else {
        return `${this.umowaOd} r.`
      }
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}
table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}
th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
ul.dashed {
  list-style-type: "- ";
  margin: 0;
}
.underline {
  text-decoration: underline;
}
.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}
#oswiadczenie {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/UmowaAneksCentrala2023.vue